import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

export interface GetDistributorStatisticQueryResult {
  distributorId: string | any;
  distributorName: string | any;
  freightCount: string | any;
  totalRevenue: number | null | any;
}

export default function useGetDistributorStatistics() {
  const [loading, setLoading] = useState(false);

  async function execute(): Promise<any> {
    try {
      setLoading(true);
      const response = await api.get('v1/backoffice/distributors/statistics');

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
